module.exports = __webpack_public_path__ + "files/fc4b90e084a3a6de02dc9affc4623497.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/animals_nature-2.png
// module id = 507
// module chunks = 76